import { render } from "./K9.vue?vue&type=template&id=c13eecc4&scoped=true"
import script from "./K9.vue?vue&type=script&lang=js"
export * from "./K9.vue?vue&type=script&lang=js"

import "./K9.vue?vue&type=style&index=0&id=c13eecc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c13eecc4"]])

export default __exports__